import { useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";

const useIdleTimer = (onLogout, timeout = 300000) => {
  const timeoutRef = useRef(null);
  const events = ["mousemove", "keydown", "scroll", "touchstart"];
  const history = useHistory();

  const resetTimeout = () => {
    if (timeoutRef?.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(onLogout, timeout);
  };

  useEffect(() => {
    const handleActivity = () => resetTimeout();

    events.forEach((event) => window.addEventListener(event, handleActivity));

    resetTimeout();

    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      events.forEach((event) =>
        window.removeEventListener(event, handleActivity)
      );
    };
  }, []);

  return history;
};

export default useIdleTimer;
